import e from "./ghl-ui.es762.js";
import o from "./ghl-ui.es745.js";
var t = Object.prototype, n = t.hasOwnProperty, s = t.propertyIsEnumerable, a = e(function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && n.call(r, "callee") && !s.call(r, "callee");
};
const m = a;
export {
  m as default
};
